exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status__title[data-v-3d0c5f55]{color:#a9b1c2;font-size:16px;font-weight:500;line-height:120%;letter-spacing:-.25px}.status__list[data-v-3d0c5f55]{display:flex;align-items:stretch;flex-wrap:wrap;margin:1.2rem -6px -6px}.status__item[data-v-3d0c5f55]{margin:6px}.status__button[data-v-3d0c5f55]{padding:10px 20px}.status__button:hover .status__icon[data-v-3d0c5f55]{color:#fff}.status__icon[data-v-3d0c5f55]{width:20px;height:20px;color:#00b4ff}.status__icon--active[data-v-3d0c5f55]{color:#fff}", ""]);

// exports
